import type { RouteIdType } from './routes';
import { RouteId } from './routes';

const boardRoutes = new Set<string>([RouteId.BOARD, RouteId.BOARD_REFERRAL]);

export const isBoardRoute = (routeId: RouteIdType): boolean =>
  boardRoutes.has(routeId);
